module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"trips":"Trips","travelers":"Travelers","employees":"Employees"},"de":{"trips":"Reisen","travelers":"Reisende","employees":"Mitarbeiter"},"fr":{"trips":"Voyages","travelers":"Voyageurs","employees":"Employés"},"pt-br":{"trips":"Viagens","travelers":"Viajantes","employees":"Funcionários"}}')
  delete Component.options._Ctor
}
